import { Card, Divider } from "antd";
import { useParams, useSearchParams } from "react-router-dom";
import { number_3_3 } from "../../utilities";
import { FiAlertCircle } from "react-icons/fi";
import "./style.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { api } from "../../api/url";

import Button from "../../components/Button";
import { toast } from "react-hot-toast";

const AboutUs = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { id, doctorid } = useParams();
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [visitInfo, setVisitInfo] = useState({});
  const [totalPrice, setTotalPrice] = useState();
  const [bank, setBank] = useState(0);

  const ReserveTime = async () => {
    let userID = await localStorage.getItem("user");

    await axios({
      url: api + "appointment/admission/getinfo",
      method: "post",
      data: {
        userId: userID,
        attenderId: doctorid,
        // serviceId: doctor?.serviceId,
        // companyId: cmpnyID,
        branchId: id,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(async (res) => {
        setVisitInfo(res.data.data);
        let pc =
          res?.data?.data?.cashAmountList[0]?.price +
          res?.data?.data?.cashAmountList[1]?.price;

        setTotalPrice(pc);

        setLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.clear();
        }
        // setVisitModal(true);
      });
  };

  useEffect(() => {
    ReserveTime();
  }, []);

  const ValidateTime = async () => {
    const user_id = await localStorage.getItem('user');

    setBtnLoading(true);
    axios({
      method: "post",
      url: api + "appointment/validateschedule/",
      data: {
        userId: user_id,
        attenderScheduleBlockId: searchParams.get("blockId")
      }
    })
      .then((res) => {
        if (res.data.data) {

          if (res.data.data.hasPatient === true && res.data.data.admissionId !== null) {
            GoPayment(res.data.data.admissionId)
          } else if (res.data.data.hasPatient === false && res.data.data.admissionId === null) {
            ConfirmTime();
          } else {
            toast.error("این نوبت قبلا ثبت شده است.");
            setBtnLoading(false);
          }
        } else {
          toast.error("این نوبت قبلا ثبت شده است.");
          setBtnLoading(false);
        }
        console.log('res.data.data ', res.data.data)
        // admissionId   
        // hasPatient

        // if (res.data.data === false) {
        //   // hasPatient : (true OR false),
        //   // admissionId : (null OR NotNull)
        //   ConfirmTime();
        // } else {
        //   toast.error("این نوبت قبلا ثبت شده است.");
        //   setBtnLoading(false);
        // }
      })
      .catch((err) => {
        console.log("err", err);
        setBtnLoading(false);
      });
  };

  // ---- TODO :confirm she ina
  const ConfirmTime = async () => {
    let active_time = JSON.parse(localStorage.getItem("active_time"));

    await axios({
      method: "post",
      url: api + "appointment/admission/save",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: {
        attenderId: visitInfo.attenderId,
        serviceId: visitInfo.serviceId,
        attenderScheduleBlockId: searchParams.get("blockId"),

        reserveNo: active_time?.reserveNo,
        reserveDatePersian: searchParams.get("day"), //?
        reserveTime: active_time?.startTime, //?

        companyId: visitInfo?.companyId,
        branchId: visitInfo.branchId,
        userId: localStorage.getItem("user"),
        patientUserMobileNo: localStorage.getItem("cellphone"),
        patientUserFirstName: visitInfo?.userFirstName,
        patientUserLastName: visitInfo?.userLastName,
        patientUserNationalCode: visitInfo?.userNationalCode,
        patientUserGenderId: visitInfo?.userGenderId,
        // terminalNo: "string",
      },
    })
      .then((res) => {
        setBtnLoading(false);
        if (res.data.successfull === true) {
          if (res.data.data.url)
            window.location.href = res.data.data.url
        } else {
          if (res.data?.httpStatus === 406 && res.data?.validationErrors !== null) {
            res.data?.validationErrors?.map((item) =>
              toast.error(item)
            )
          } else {
            toast.error("خطا در ثبت");
          }
        }
        // window.location.href = "/profile/history";
      })
      .catch((err) => {
        toast.error("خطا در ثبت");
        console.log("err", err);
      });
  };

  const GoPayment = async (admissionId) => {

    await axios({
      method: "get",
      url: api + "appointment/admission/payment/" + admissionId,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      }
    })
      .then((res) => {
        setBtnLoading(false);
        if (res.data?.httpStatus === 406 && res.data?.validationErrors !== null) {
          res.data?.validationErrors?.map((item) =>
            toast.error(item)
          )
        } else if (res.data.successfull === true) {
          if (res.data.data.url)
            window.location.href = res.data.data.url

        } else {
          if (res.data?.httpStatus === 406 && res.data?.validationErrors !== null) {
            res.data?.validationErrors?.map((item) =>
              toast.error(item)
            )
          } else {
            toast.error("خطا در ثبت");
          }
        }
        // window.location.href = "/profile/history";
      })
      .catch((err) => {
        toast.error("خطا در ثبت");
        console.log("err", err);
      });
  };




  if (loading) {
    return <Card className="factor-card">loading</Card>;
  } else
    return (
      <div className="factor-container ">
        <Card className="factor-card">
          <h4>پرداخت و ثبت نوبت</h4>
          <div className="visit-modal-confirm-content">
            <div className="row">
              <div className="col-lg-6 col-6 ">نام‌و‌نام‌خانوادگی:</div>
              <div className="col-lg-6 col-6 visit-modal-left">
                {visitInfo?.userFullName}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-6">
                کدملی: {visitInfo?.userNationalCode}
              </div>
              <div className="col-lg-6 col-6 visit-modal-left">
                شماره‌تماس: {localStorage.getItem("cellphone")}
              </div>
            </div>

            <Divider />
            <div className="row">
              <div className="col-lg-6 col-6">
                {" "}
                نام‌پزشک: {visitInfo?.attenderFullName}
              </div>
              <div className="col-lg-6 col-6 visit-modal-left">
                تخصص: {visitInfo?.attenderSpecialityName}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 ">
                شماره تماس: {visitInfo?.branchPhoneNo}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 ">
                آدرس: {visitInfo?.branchAddress}{" "}
              </div>
            </div>
            <Divider />
            <div className="row">
              <div className="col-lg-6 col-6 ">
                {" "}
                تاریخ: {searchParams.get("day")}
              </div>
              <div className="col-lg-6 col-6 visit-modal-left">
                ساعت: {searchParams.get("time")}
              </div>
            </div>
            <Divider />
            {visitInfo?.cashAmountList.map((item) => (
              <div className="row">
                <div className="col-lg-6  col-6">
                  {item.fundTypeId === 18 ? "خدمات آنلاین" : "نوبت"}
                </div>
                <div className="col-lg-6 col-6 visit-modal-left">
                  {number_3_3(item.price)} ریال
                </div>
              </div>
            ))}
            <Divider />
            <div className="row">
              <div className="factor-price col-lg-6  col-6">مبلغ قابل پرداخت</div>
              <div className="factor-price col-lg-6 col-6 visit-modal-left">
                {number_3_3(String(totalPrice))} ریال
              </div>
            </div>
            <Divider />

            {/* <div className="factor-banklist-container">
              <div
                onClick={() => setBank(0)}
                className="col-lg-6 col-12 left-bank-btn"
              >
                <a className={bank === 0 && "active-bank"}>بانک پاسارگاد</a>
              </div>

              <div
                onClick={() => setBank(1)}
                className="col-lg-6 col-12 right-bank-btn"
              >
                <a className={bank === 1 && "active-bank"}>بانک ملت</a>
              </div>
            </div> */}
          </div>

          <div className="factor-page-warning">
            <FiAlertCircle />
            <p>
              مراجعه کننده گرامی! رزرو نوبت منوط به پرداخت وجه و دریافت پیامک شناسه نوبت می باشد، در غیراینصورت وجه کسر شده از حساب طی 72 ساعت عودت می گردد.
            </p>
          </div>

          <div className="factor-page-warning">
            <FiAlertCircle />
            <p>
              وجه شما مستقیما به حساب مرکز درمانی واریز می گردد، لذا در صورت کنسلی نوبت می بایست عودت وجه را از مرکز مربوطه پی گیری نمایید
            </p>
          </div>


          <Button
            isSubmitting={btnLoading}
            onClick={() => ValidateTime()}
            className="modal-phonenumber-container-button"
          >
            پرداخت و دریافت نوبت
          </Button>
        </Card>
      </div>
    );
};

export default AboutUs;
